import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Social from './components/social';
import Categories from './components/categories';
import Link from 'react-router-dom/Link';
import outerHeight from '../../../utils/outerheight_util';
import matchMediaDesktop from '../../../utils/client_util';
import Notice from './components/notice';

class Masthead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      active: true
    };

    // NOTIFICATION KILLSWITCH
    this.showNotice = true;

    this.lastScroll = 0;
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeActiveMenu = this.closeActiveMenu.bind(this);
    this.navTimeout = undefined;
    this.mastcontainer = React.createRef();
    this.handleTopNavAdPositioning = this.handleTopNavAdPositioning.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    if (typeof window.queryly !== 'undefined') {
      window.queryly.init(
        'c99eafd2993b450c',
        document.getElementsByClassName('masthead__search')
      );
    }

    this.handleNavScroll = throttle(this.handleNavScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleNavScroll);

    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleNavScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    }
  }

  handleNavScroll() {
    const currentScroll = window.pageYOffset;
    const latestScroll = this.lastScroll;

    if (currentScroll > latestScroll && latestScroll > 1 && this.state.active) {
      this.setState({ active: false });
    } else if (
      (currentScroll < latestScroll || latestScroll < 1) &&
      !this.state.active
    ) {
      this.setState({ active: true });
    }
    this.lastScroll = currentScroll;
  }

  handleTopNavAdPositioning() {
    if (!this.topNavAd) {
      this.topNavAd = document.querySelector('.homepage-page__ff-ad-container');
    }

    if (this.topNavAd) {
      const height = outerHeight(this.topNavAd);
      // debugger;
      if (window.scrollY >= height) {
        this.mastcontainer.style = 'position: fixed;';
      } else {
        this.mastcontainer.style = 'position: relative;';
      }
    }
  }

  handleResize() {
    window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
      this.handleTopNavAdPositioning();
    }
  }

  toggleMenu() {
    this.setState({ menu: !this.state.menu });
  }

  closeActiveMenu() {
    this.navTimeout = setTimeout(() => {
      this.setState({ active: false });
    }, 2000);
  }

  render() {
    const {
      topics,
      channels,
      trackClick,
      config,
      activeCategory,
      hasTopNavAd
    } = this.props;
    const { menu, active } = this.state;
    const site = get(this.props.config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);

    return (
      <React.Fragment>
        {this.showNotice && <Notice />}
        <div
          ref={mastcontainer => {
            this.mastcontainer = mastcontainer;
          }}
          className={hasTopNavAd ? 'masthead masthead--top-nav-ad' : 'masthead'}
          onMouseEnter={() => {
            clearTimeout(this.navTimeout);
            this.setState({ active: true });
          }}
          onMouseLeave={this.closeActiveMenu}
        >
          <header className="masthead__header">
            <Link to="/" className="masthead__title">
              <h2>Fast Company</h2>
            </Link>
            <button onClick={this.toggleMenu} className="masthead__menu" />
            <div className="masthead__interactive">
              <Social data={social} trackClick={trackClick} />
              <button className="masthead__search">
                <i className="icon-search-glass" />
              </button>
            </div>
          </header>
          <Categories
            topics={topics}
            channels={channels}
            active={active}
            activeCategory={activeCategory}
            trackClick={trackClick}
          />
          <MainMenu
            closeMenu={this.toggleMenu}
            mainMenuVisible={menu}
            config={config}
            topics={topics}
            {...mainMenuContext}
          />
        </div>
      </React.Fragment>
    );
  }
}

Masthead.propTypes = {
  config: PropTypes.shape({}).isRequired,
  topics: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trackClick: PropTypes.func,
  activeCategory: PropTypes.string.isRequired,
  hasTopNavAd: PropTypes.bool.isRequired
};

Masthead.defaultProps = {
  trackClick: () => {}
};

export default Masthead;
